const copy = {
  preparing: ["Versand wird vorbereitet", "Preparing email"],
  pending: ["E-Mail wartet auf Versand", "Email waiting to be sent"],
  sending: ["E-Mail wird versendet", "Email is being sent"],
  retry_wait: ["Versand verzögert – erneuter Versuch läuft", "Sending delayed – retry scheduled"],
  blocked: ["Versand derzeit nicht möglich", "Sending currently unavailable"],
  acceptance_unknown: ["Versandbestätigung fehlt – Status wird geprüft", "Send confirmation missing – checking status"],
  provider_accepted: ["E-Mail versendet", "Email sent"],
  failed_permanent: ["Versand fehlgeschlagen", "Sending failed"],
  retry_exhausted: ["Automatische Versandversuche ausgeschöpft", "Automatic send attempts exhausted"],
  cancelled: ["Versand abgebrochen", "Sending cancelled"],
  expired: ["Link abgelaufen", "Link expired"],
};

export const systemMailStatusLabel = (status, lang = "de") =>
  copy[status]?.[lang === "de" ? 0 : 1] || (lang === "de" ? "Versandstatus wird geprüft" : "Checking send status");

export const systemMailInFlight = (status) =>
  ["preparing", "pending", "sending", "retry_wait", "acceptance_unknown"].includes(status);

export const systemMailBusinessResendAllowed = (status) =>
  !status || ["provider_accepted", "expired", "cancelled", "failed_permanent", "retry_exhausted"].includes(status);
